/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{flex:auto;display:block}.filter-panel[_ngcontent-%COMP%]{position:relative;justify-items:start;padding:10px;background-color:#f5f5f5}"];
export { styles as styles };
